import React from 'react';
import { Tag } from 'antd';

const getLengthInfo = (value: string) => {
  const chars = value.length;
  const bytes = new Blob([value]).size;
  const words = value.trim().split(/\s+/).filter(Boolean).length;
  return { chars, bytes, words };
};

const LengthTags: React.FC<{ value: string; showWordCount?: boolean }> = ({ value, showWordCount }) => {
  const { chars, bytes, words } = getLengthInfo(value || '');
  return (
    <span style={{ marginLeft: 8 }}>
      <Tag color="blue">{chars} chars</Tag>
      <Tag color="geekblue">{bytes} bytes</Tag>
      {showWordCount && <Tag color="purple">{words} words</Tag>}
    </span>
  );
};

export { LengthTags };

